export type ExtraIconKind =
    | 'hours'
    | 'cleaning'
    | 'cleaning_terrace'
    | 'perrito'
    | 'sandwich'
    | 'merienda'
    | 'catering'
    | 'monitor'
    | 'mago'
    | 'payaso'
    | 'castillo'
    | 'pizza'
    | 'escape'
    | 'cluedo'
    | 'decoration'
    | 'carrito'
    | 'nino'
    | 'personaje'
    | 'camarero'
    | 'slime'
    | 'almacenaje'
    | 'gift'
    | 'generic';

function normalize(text: string): string {
    return text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
}

export function resolveExtraIconKind(name: string): ExtraIconKind {
    const value = normalize(name);

    if (value.includes('hora')) return 'hours';
    if (value.includes('terraza')) return 'cleaning_terrace';
    if (value.includes('limpieza') || value.includes('cleaning')) return 'cleaning';
    // Keep Merienda (modality include) on the shared cupcake; perrito packs get their own icon.
    if (value.includes('perrito')) return 'perrito';
    if (value.includes('sandwich') || value.includes('caja con sand')) return 'sandwich';
    if (value.includes('merienda')) return 'merienda';
    if (value.includes('picoteo') || value.includes('catering')) return 'catering';
    if (value.includes('monitor')) return 'monitor';
    if (value.includes('mago')) return 'mago';
    if (value.includes('payaso')) return 'payaso';
    if (value.includes('cluedo')) return 'cluedo';
    if (value.includes('escape')) return 'escape';
    if (value.includes('castillo') || value.includes('hinchable')) return 'castillo';
    if (value.includes('pizza')) return 'pizza';
    if (value.includes('deco') || value.includes('decor')) return 'decoration';
    if (value.includes('carrito')) return 'carrito';
    if (value.includes('nino extra')) return 'nino';
    if (value.includes('personaje')) return 'personaje';
    if (value.includes('camarero')) return 'camarero';
    if (value.includes('slime')) return 'slime';
    if (value.includes('almacen')) return 'almacenaje';

    return 'generic';
}
